import { Box, Grid, Skeleton as MuiSkeleton, Stack } from '@mui/material';
import { PageContainer } from '@/components/shared/page-container';

const ProfileSkeleton = () => (
  <Box>
    <Stack direction="row" spacing={3} alignItems="center" mb={2}>
      <MuiSkeleton variant="circular" width={70} height={70} />
      <MuiSkeleton variant="text" width="30%" height={44} />
    </Stack>
    <Stack direction="row" mt={3} spacing={2}>
      <MuiSkeleton variant="rounded" width="33%" height={100} />
      <MuiSkeleton variant="rounded" width="33%" height={100} />
      <MuiSkeleton variant="rounded" width="33%" height={100} />
    </Stack>
  </Box>
);

const PPSkeleton = () => (
  <Box>
    <MuiSkeleton variant="rounded" width="40%" height={20} sx={{ my: 2 }} />
    <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, md: 8 }}>
          <Stack spacing={2}>
            <MuiSkeleton variant="rounded" width="60%" height={24} />
            <MuiSkeleton variant="rounded" width="80%" height={20} />
            <MuiSkeleton variant="rounded" width="40%" height={16} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  </Box>
);

const CardsSkeleton = ({ withTextSkeleton = true }) => (
  <Box>
    {withTextSkeleton && (
      <>
        <MuiSkeleton variant="rounded" width="40%" height={20} />
        <MuiSkeleton variant="rounded" width="70%" height={16} sx={{ my: 2 }} />
      </>
    )}
    <Stack direction="row" spacing={2}>
      {[1, 2, 3, 4].map((item) => (
        <Box key={item} sx={{ border: '1px solid #e0e0e0', borderRadius: 1 }}>
          <MuiSkeleton
            variant="rectangular"
            width={270}
            height={100}
            sx={{ borderTopRightRadius: 1, borderTopLeftRadius: 1 }}
          />
          <Stack spacing={2} flex={1} p={3} height={200}>
            <MuiSkeleton variant="rounded" width="70%" height={20} />
            <MuiSkeleton variant="rounded" width="50%" height={16} />
            <MuiSkeleton variant="rounded" width="30%" height={14} />
          </Stack>
        </Box>
      ))}
    </Stack>
  </Box>
);

const Skeleton = () => {
  return (
    <PageContainer>
      <Stack spacing={7} sx={{ py: 3, overflow: 'hidden' }}>
        <ProfileSkeleton />
        <PPSkeleton />
        <CardsSkeleton />
        <CardsSkeleton />
        <CardsSkeleton />
      </Stack>
    </PageContainer>
  );
};

export { Skeleton, ProfileSkeleton, PPSkeleton, CardsSkeleton };
